(() => {
  (() => {
    class t extends HTMLElement {
      currentVariant;
      form;
      swatch;
      input;
      prices;
      priceDiscount;
      specialDiscount;
      option0;
      option1;
      option2;
      option3;
      imageBar;
      stars;
      button;
      save_additional;
      affirmText;
      gallery;
      gallery2;
      nGallery;
      nVideo;
      image;
      select;
      noSelect;
      options;
      wrapper;
      afterPayPrice;
      additionalText;
      shopBarToggles;
      quantitySelector;
      constructor() {
        super(),
          (this.currentVariant = window.theme.product.currentVariant),
          (this.form = this.querySelector("form")),
          (this.swatch = this.querySelector("#variantPicker")),
          (this.save_additional = this.querySelector(
            ".discount-additional-text"
          )),
          (this.input = this.form.querySelector('input[name="id"]')),
          (this.prices = this.querySelectorAll(".product-price")),
          (this.priceDiscount = this.querySelectorAll(
            ".product-price-discount"
          )),
          (this.specialDiscount = this.querySelectorAll(
            ".special-discount-item"
          )),
          (this.imageBar = document.querySelector(".shop-bar_image")),
          (this.stars = this.querySelector("[data-oke-star-rating]")),
          (this.button = this.querySelector(".product-form__submit")),
          (this.affirmText = this.querySelector(".affirm-as-low-as")),
          (this.gallery = document.querySelector(
            "product-form .product-gallery"
          )),
          (this.gallery2 = document.querySelector(
            ".product-gallery-grid .product-gallery"
          )),
          (this.nGallery = document.querySelector(".product-gallery-grid")),
          (this.nVideo = document.querySelector(
            ".product-gallery-grid .product-gallery_item-video"
          )),
          (this.wrapper = document.querySelector(".product__info-wrapper")),
          (this.additionalText = document.querySelector(
            "#product-form_additional-text"
          )),
          (this.afterPayPrice = document.querySelector(".afterpay-price")),
          (this.productLabel = document.querySelector(
            "#best-seller-label-pdp"
          )),
          (this.submitting = !1),
          (this.shopBarToggles = this.querySelectorAll(".shop-bar-toggle")),
          (this.quantitySelector = this.querySelector(".quantity")),
          "Gift Card" === window.theme.product.type &&
            ((this.image = document.querySelector(
              "product-form .product-gallery img"
            )),
            (this.select = this.swatch.querySelector(
              ".blanket-options_select"
            )),
            (this.noSelect = !0),
            this.select.addEventListener(
              "click",
              this.handleSelect.bind(this)
            )),
          this.swatch &&
            ((this.option0 = this.swatch.querySelector(
              ".product_option0-value"
            )),
            (this.option1 = this.swatch.querySelector(
              ".product_option1-value"
            )),
            (this.option2 = this.swatch.querySelector(
              ".product_option2-value"
            )),
            (this.option3 = this.swatch.querySelector(
              ".product_option3-value"
            )),
            this.swatch.addEventListener(
              "change",
              this.onVariantChange.bind(this)
            ),
            (this.firstLoad = !0),
            this.onVariantChange(),
            this.showOnlyAvailableColors()),
          this.form.addEventListener("submit", this.handleForm.bind(this)),
          this.classList.contains("shop-bar-disabled") ||
            window.addEventListener("scroll", this.handleScroll.bind(this)),
          this.stars &&
            this.stars.addEventListener("click", () => {
              const t = document.querySelector(
                "[data-oke-carousel], [data-oke-widget]"
              );
              t &&
                window.scrollTo({ top: t.offsetTop - 70, behavior: "smooth" });
            }),
          this.handleLables(),
          this.handleSkuPrime();
      }
      showOnlyAvailableColors() {
        const t = this.swatch.querySelectorAll('input[name="Color"]');
        window.theme.hideUnavailableWeights &&
          t &&
          t.forEach((t) => {
            window.theme.product.variants.find(
              (e) => e.options[0] === t.value && e.available
            ) || t.nextElementSibling.setAttribute("hidden", "");
          });
      }
      handleSkuPrime() {
        let t = window.theme.product.skuPrime,
          e = !1;
        if (void 0 !== t)
          for (let i = 0; i < t.length; i++)
            t[i] == window.theme.product.currentVariant.sku && (e = !0);
      }
      handleLables() {
        "Gift Card" !== window.theme.product.type &&
          this.productLabel &&
          ((this.productLabel.innerHTML =
            this.currentVariant.variant_label || ""),
          (this.productLabel.style.background =
            this.currentVariant.variant_label_color || ""));
      }
      handleScroll() {
        const t = this.parentElement,
          e = this.classList.contains("shop-bar"),
          i = this.formVisible();
        i && e
          ? ("" !== t.style.minHeight && (t.style.minHeight = ""),
            this.classList.remove("shop-bar"))
          : i ||
            e ||
            ("" === t.style.minHeight &&
              (t.style.minHeight = t.offsetHeight + "px"),
            this.classList.add("shop-bar"));
      }
      formVisible() {
        let t = this.wrapper.offsetTop - 70,
          e = this.wrapper.offsetLeft,
          i = this.wrapper.offsetWidth,
          r = this.wrapper.offsetHeight;
        return (
          t < window.pageYOffset + window.innerHeight &&
          e < window.pageXOffset + window.innerWidth &&
          t + r > window.pageYOffset &&
          e + i > window.pageXOffset
        );
      }
      handleForm(t) {
        if ((t.preventDefault(), this.submitting)) return;
        this.submitting = !0;
        const e = this.querySelector('[type="submit"]');
        e && (e.setAttribute("disabled", "true"), e.classList.add("loading"));

        if (window.theme.product.template == "biscuit-bundle") {
          const formData = new FormData(this.form);
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: formData })
            // fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => {
              window.theme.cart.render(t, !0); // Pass the response to the render function
            })
            .catch((e) => {
              console.error("CART ERROR: ", e), t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              const t = document.querySelector(".close");
              t && t.click();
            });
        } else {
          const i = JSON.stringify({
            ...JSON.parse(window.theme.utils.serializeForm(this.form)),
          });
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => t.json())
            .then((t) => {
              window.theme.cart.render(!0);
            })
            .catch((e) => {
              console.error("CART ERROR: ", e), t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              const t = document.querySelector(".close");
              t && t.click();
            });
        }
      }
      onVariantChange() {
        this.updateOptions(),
          this.updateMasterId(),
          this.updateMedia(),
          this.checkAvailability(),
          this.updateURL(),
          this.updateVariantInput(),
          (window.theme.product.currentVariant = this.currentVariant),
          this.changeElements(),
          this.handleLables(),
          this.handleSkuPrime(),
          this.handleLpColors(),
          this.updateAfterpay(),
          this.currentVariant.options.forEach((t, e) => {
            this.setAttribute(`data-option${e + 1}`, t);
          }),
          40597836693690 === this.currentVariant.id
            ? this.button.classList.add("hidden")
            : this.button.classList.remove("hidden"),
          "product" in this.currentVariant &&
            (window.theme.product.title = this.currentVariant.product),
          this.updateAffirm(),
          this.noSelect &&
            !this.select.hasAttribute("open") &&
            (this.select.setAttribute("selected", ""), (this.noSelect = !1));
      }
      updateAfterpay() {
        // if (document.querySelector("afterpay-placement")) {
        //     const t = document.querySelector(".product-price-compare")
        //     ? document.querySelector(".product-price-compare").textContent
        //     : this.currentVariant.price;
        //     const i = document.querySelector("afterpay-placement");
        //     if (null !== i.shadowRoot) {
        //       const r = i.shadowRoot.querySelector(".afterpay-main-text"),
        //         o = r.textContent;
        //         o.includes(t) || (r.textContent = t + " " + o);
        //     }
        // }

        //update the data attribute data-mobile-price for the element .afterpay-price based on the current product price

        if (this.afterPayPrice) {
          const t = this.currentVariant.price;
          this.afterPayPrice.dataset.mobilePrice = t;
        }
      }
      updateAffirm() {
        if (
          this.affirmText &&
          "undefined" != typeof affirm &&
          affirm.jsReady()
        ) {
          const t = this.currentVariant.price.replace("$", "") + "00";
          this.affirmText.setAttribute("data-amount", t), affirm.ui.refresh();
        }
      }
      updateOptions() {
        const t = Array.from(this.swatch.querySelectorAll("fieldset"));
        (this.options = t.map((t) => {
          const e = Array.from(t.querySelectorAll("input")).find(
            (t) => t.checked
          );
          return !!e && e.value;
        })),
          window.theme.product.landing && this.options.shift();
      }
      updateMasterId() {
        const t = window.theme.hideUnavailableWeights,
          e = this.currentVariant.sizes.join(",");
        if (
          ((this.currentVariant = window.theme.product.variants.find(
            (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
          )),
          this.currentVariant ||
            (this.currentVariant = window.theme.product.variants.find(
              (t) => t.options[0] === this.options[0]
            )),
          t &&
            "Color" === window.theme.product.options[0] &&
            "Weight (lbs)" === window.theme.product.options[1])
        ) {
          this.setAttribute("data-hide-weights", "true");
          const t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          if (0 === t.length) return;
          for (var i = 0; i < t.length; i++) {
            var r = t[i];
            const e = r.value;
            var o = r.nextElementSibling;
            window.theme.product.variants.find(
              function (t) {
                return (
                  t.options[1] === e &&
                  t.options[0] === this.currentVariant?.options?.[0] &&
                  t.available
                );
              }.bind(this)
            )
              ? o.removeAttribute("hidden")
              : o.setAttribute("hidden", "");
          }
          const e = this.querySelector(
            'input[name="' +
              window.theme.product.options[1] +
              '"] + label:not([hidden])'
          );
          !this.currentVariant?.available && e && e.click();
        } else if (this.currentVariant.sizes.join(",") !== e) {
          this.querySelector(
            'input[value="' + this.currentVariant.options[1] + '"]'
          ).click(),
            (this.options = this.currentVariant.options);
          let t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          if (0 === t.length) return;
          for (let e = 0; e < t.length; e++) {
            const i = t[e],
              r = i.nextElementSibling;
            this.currentVariant.sizes.includes(i.value)
              ? r.removeAttribute("hidden")
              : r.setAttribute("hidden", "");
          }
        }
      }
      updateMedia() {
        if ("Sleeper" !== window.theme.product.title) {
          if ("Gift Card" === window.theme.product.type) {
            const t = window.theme.product.images[this.currentVariant.color][1];
            (this.image.src = t.src),
              (this.image.alt = t.alt),
              this.updateGallery(
                window.theme.product.images[this.currentVariant.color]
              );
          } else {
            const t = window.theme.product.landing
              ? window.theme.product.images[this.currentVariant.product][
                  this.currentVariant.color
                ]
              : window.theme.product.images[this.currentVariant.color];
            t &&
              (this.gallery.update(t, window.theme.product.video),
              this.gallery2 &&
                this.gallery2.update(t, window.theme.product.video),
              this.updateGallery(t));
          }
          (this.imageBar.src = this.currentVariant.image),
            window.theme.product.videoObserverInit &&
              window.theme.product.videoObserverInit();
        }
      }
      updateGallery(t) {
        if ("true" === this.nGallery.dataset.slider || 0 === t.length) return;
        let e = "";
        t.forEach(function (t, i) {
          e += `\n      <div class="product-gallery_item product-gallery_item-image pointer">  \n        <div class="media media--square">\n          <img src="${t.src}" alt="${t.alt}" width="800" height="1000" class="cover-image" loading="lazy" onclick="window.theme.product.modal(${i})">\n        </div>\n      </div>`;
        }),
          window.theme.product.video
            ? (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${window.theme.product.video.image}" onclick="window.theme.product.modal(${t.length})">\n          <source src="${window.theme.product.video.src}" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`)
            : window.theme.product.videos &&
              window.theme.product.videos[this.currentVariant.product] &&
              (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${
                window.theme.product.videos[this.currentVariant.product].image
              }" onclick="window.theme.product.modal(${
                t.length
              })">\n          <source src="${
                window.theme.product.videos[this.currentVariant.product].src
              }" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`),
          (this.nGallery.innerHTML = e);
      }
      updateURL() {
        if (window.theme.product.landing) return;
        if (this.firstLoad) return void (this.firstLoad = !1);
        const t = new URLSearchParams(window.location.search);
        t.set("variant", this.currentVariant.id);
        const e = window.location.pathname + "?" + t.toString();
        history.pushState(null, "", e);
      }
      updateVariantInput() {
        (this.input.value = this.currentVariant.id),
          this.input.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      checkAvailability() {
        this.currentVariant.available
          ? this.removeAttribute("soldout")
          : this.setAttribute("soldout", "");
      }
      
      changeElements() {
        if (window.theme.product.currentVariant.is_preoder === "true") {
          document.querySelector("#product-form_preorder-text").style.display =
            "block";

          let preorderText = window.theme.product.currentVariant.preorder_text;

          if (window.location.pathname.includes("/de")) {
            preorderText = preorderText
              .replace("Ships by the week of", "Wird versendet in der Woche ab")
              .replace(/(\d+)(th|nd|st|rd)/g, "$1")
              .replace("January", "Januar")
              .replace("February", "Februar")
              .replace("March", "März")
              .replace("April", "April")
              .replace("May", "Mai")
              .replace("June", "Juni")
              .replace("July", "Juli")
              .replace("August", "August")
              .replace("September", "September")
              .replace("October", "Oktober")
              .replace("November", "November")
              .replace("December", "Dezember");

            this.button.innerHTML = "VORBESTELLEN";
          } else {
            this.button.innerHTML = "PRE-ORDER";
          }

          document.querySelector("#product-form_preorder-text").innerHTML =
            preorderText;
        } else {
          if (window.location.pathname.includes("/de")) {
            this.button.innerHTML = "IN DEN WARENKORB";
          } else {
            this.button.innerHTML = "ADD TO CART";
          }
          document.querySelector("#product-form_preorder-text").style.display =
            "none";
        }

        const t = document.querySelectorAll(
            ".product-price-compare.compare-price"
          ),
          e = document.querySelectorAll(".tag--save"),
          i = document.querySelectorAll(".compare-price-cart.product-price");
        let r = this.currentVariant.price,
          o = parseFloat(r.replace("$", ""));
        var n = 0;
        if (
          ((o = o.toFixed(0)),
          t.forEach((t) => {
            let r = !1;
            this.specialDiscount.forEach((o) => {
              if (o.innerHTML == window.theme.product.currentVariant.id)
                return (
                  (n = 1 - o.dataset.specialDiscount / 100),
                  t.classList.add("red"),
                  (document.querySelector(
                    ".discount-additional-text-wrapper"
                  ).style.display = "block"),
                  (this.save_additional.style.display = "inline-block"),
                  (i[0].style.display = "block"),
                  e.forEach((t) => {
                    (t.dataset.textDiscount =
                      o.dataset.specialDiscount + "% off"),
                      (t.style.display = "flex"),
                      (this.save_additional.innerHTML =
                        "Save " + o.dataset.specialDiscount + "% ");
                  }),
                  void (r = !0)
                );
            }),
              r ||
                ((n = 1 - t.dataset.discount / 100),
                t.classList.add("red"),
                (document.querySelector(
                  ".discount-additional-text-wrapper"
                ).style.display = "block"),
                (this.save_additional.style.display = "inline-block"),
                (i[0].style.display = "block"),
                (this.save_additional.innerHTML =
                  "Save " + t.dataset.discount + "% "),
                e.forEach((e) => {
                  (e.dataset.textDiscount = t.dataset.discount + "% off"),
                    (e.style.display = "flex");
                })),
              (t.innerHTML = `$${Math.round(o * n)}`),
              (this.button.dataset.mobilePrice = `$${Math.round(o * n)}`);
          }),
          this.prices.forEach((t) => {
            t.innerHTML = this.currentVariant.price;
          }),
          this.priceDiscount.forEach((t) => {
            let e = parseFloat(
                this.currentVariant.price.replace(/[^0-9.-]+/g, "")
              ),
              i = Math.ceil(1.11 * e);
            t.innerHTML = "$" + i.toFixed(0);
          }),
          (this.button.dataset.bundlePrice = this.currentVariant.price),
          (this.button.dataset.unitPrice = this.currentVariant.price))
        );
        const currentPath = window.location.pathname;

        const colorTranslations = {
          "Midnight Blue": "Nachtmarine",
          "Moonstone Grey": "Mondstein-Grau",
          "Asteroid Grey": "Nachtruhe-Grau",
          "Driftwood": "Sandelholz",
          "Sweet Lavender": "Süßlavendel",
          "Holliberry": "Burgunderrot",
          "Hollyberry": "Burgunderrot",
          "Moonbeam": "Mondschein",
          "Seashell": "Sonnenkoralle",
          "Starry Night": "Sternennacht",
          "Evening Rose": "Wildrose",
          "Confetti": "Konfetti",
          "Morning Matcha": "Matcha",
          "Blue Spruce": "Salbeiblüte",
          "Base Cover (White)": "Basis-Bezug, weiß",
          "Base Cover (White)": "Basis-Bezug, weiß",
          "Bluebell": "Glockenblume",
          "Twilight Sky": "Morgendämmerung"
        };
        if (this.option1) {
          this.option1.innerHTML = this.currentVariant.options[0];
          if (window.location.pathname.includes("/de")) {
            const englishColor = this.currentVariant.options[0];
            if (colorTranslations[englishColor]) {
              this.option1.innerHTML = colorTranslations[englishColor];
            }
          }
        }

        if (
          window.theme.product.options[1] &&
          window.theme.product.options[1].includes("Weight")
        ) {
          if (this.option2)
            this.option2.innerHTML =
              this.currentVariant.options[1]
                .replace("Queen ", "")
                .replace("King ", "") +
              " kg " +
              window.theme.getDimension(this.currentVariant.options[1]);
        } else if (
          window.theme.product.options[0] === "Size" &&
          window.theme.product.title === "Sleeper"
        ) {
          if (this.option1)
            this.option1.innerHTML =
              this.currentVariant.options[0] +
              window.theme.getDimension(this.currentVariant.options[0]);
        } else if (
          window.theme.product.options[1] &&
          window.theme.product.options[1] === "Size" &&
          window.theme.product.type !== "Gift Card"
        ) {
          let option = this.currentVariant.options[1];
          if (option === "Small" && window.theme.product.title === "Pupper Pod")
            option = "Small1";
          else if (
            option === "Medium" &&
            window.theme.product.title === "Pupper Pod"
          )
            option = "Medium1";
          if (this.option2)
            this.option2.innerHTML =
              this.currentVariant.options[1] +
              window.theme.getDimension(option);
        } else if (this.option2)
          this.option2.innerHTML = this.currentVariant.options[1];

        if (this.option0) {
          this.option0.innerHTML = this.currentVariant.product;
          this.option0.href =
            window.theme.product.urls[this.currentVariant.product] || "";
        }

        if (window.theme.extraColors && this.productLabel) {
          const includes = window.theme.extraColors.includes(
            this.currentVariant.options[0]
          );
          const inSecond = this.option1
            .closest(".form__label")
            .classList.contains("form__label--2");
          if (includes && !inSecond) {
            this.swatch
              .querySelector(".form__label--2")
              .appendChild(this.option1);
            this.swatch
              .querySelector(".form__label--2")
              .appendChild(this.productLabel);
          } else if (!includes && inSecond) {
            this.swatch
              .querySelector(".form__label--1")
              .appendChild(this.option1);
            this.swatch
              .querySelector(".form__label--1")
              .appendChild(this.productLabel);
          }
        }
      }
      handleSelect(t) {
        "INPUT" !== t.target.tagName &&
          (this.select.hasAttribute("open")
            ? this.select.removeAttribute("open")
            : this.select.setAttribute("open", ""));
      }
      handleLpColors() {
        const t = this.querySelector('[name="Type"]:checked');
        "weight-lp" === this.dataset.type &&
          t &&
          (this.querySelectorAll(".swatch-color label:not([hidden])").forEach(
            (e) => {
              e.dataset.product === t.value
                ? e.classList.remove("d-none")
                : e.classList.add("d-none");
            }
          ),
          this.querySelector('[name="Color"]:checked + label.d-none') &&
            this.querySelector(
              '[name="Color"] + label:not(.d-none):not([hidden])'
            ).click());
      }
    }
    customElements.define("product-form", t),
      (function () {
        var t = document.querySelector("#product-zoom-modal");
        if (t) {
          const r = t.querySelector("img"),
            o = t.querySelector("video"),
            n = t.querySelector(".slider-next"),
            s = t.querySelector(".slider-prev");
          function e(t) {
            let e,
              i = parseInt(r.dataset.index);
            e = window.theme.product.landing
              ? window.theme.product.images[
                  window.theme.product.currentVariant.product
                ][window.theme.product.currentVariant.color]
              : "Sleeper" === window.theme.product.title
              ? window.theme.product.images.sleeper
              : window.theme.product.images[
                  window.theme.product.currentVariant.color
                ];
            const n = e.length - 1;
            if (o && (("next" === t && i === n) || ("prev" === t && 0 === i))) {
              o.removeAttribute("hidden");
              const t = o.play();
              return (
                void 0 !== t &&
                  t.catch(function (t) {
                    console.log("error: ", t);
                  }),
                void (r.dataset.index = e.length.toString())
              );
            }
            "next" === t
              ? i >= n
                ? (i = 0)
                : i++
              : "prev" === t && (0 === i ? (i = n) : i--),
              (r.src = ""),
              o && !o.paused && (o.pause(), o.setAttribute("hidden", "")),
              (r.src = e[i].src),
              (r.dataset.index = i.toString());
          }
          (window.theme.product.modal = function (e) {
            let i;
            if (
              ((i = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][
                    this.currentVariant.color
                  ]
                : "Sleeper" === window.theme.product.title
                ? window.theme.product.images.sleeper
                : window.theme.product.images[this.currentVariant.color]),
              i)
            ) {
              if (e === i.length) {
                o.removeAttribute("hidden");
                const t = o.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    console.log("error: ", t);
                  });
              } else {
                (r.src = ""),
                  o && !o.paused && (o.pause(), o.setAttribute("hidden", ""));
                const t = i[e];
                r.src = t.src.replace("_800x", "");
              }
              (r.dataset.index = e.toString()),
                document.body.classList.add("body_fade"),
                document.body.classList.add("header_fade"),
                t.setAttribute("open", "");
            }
          }),
            n.addEventListener("click", function () {
              e("next");
            }),
            s.addEventListener("click", function () {
              e("prev");
            });
        }
        const i = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              const e = t.target;
              if (t.isIntersecting) {
                const t = e.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    console.log("error: ", t);
                  });
              } else e.pause();
            });
          },
          { threshold: 0.2 }
        );
        document.querySelectorAll(".product-gallery video").forEach((t) => {
          i.observe(t);
        });
      })();
  })();
  const t = document.querySelectorAll("[data-tab-target]"),
    e = document.querySelectorAll("[data-tab-content]");
  t.forEach((i) => {
    i.addEventListener("click", () => {
      const r = document.querySelector(i.dataset.tabTarget);
      e.forEach((t) => {
        t.classList.remove("active");
      }),
        t.forEach((t) => {
          t.classList.remove("active");
        }),
        i.classList.add("active"),
        r.classList.add("active");
    });
  });
  class i extends HTMLElement {
    constructor() {
      super(),
        (this.originalHTML = this.innerHTML),
        (this.originalTextContent = this.textContent);
    }
    static get observedAttributes() {
      return ["limit", "open"];
    }
    get less() {
      return this.getAttribute("less");
    }
    get more() {
      return this.getAttribute("more");
    }
    get limit() {
      return this.hasAttribute("limit")
        ? Number(this.getAttribute("limit"))
        : 10;
    }
    get isOpen() {
      return this.hasAttribute("open");
    }
    attributeChangedCallback(t, e, i) {
      this.render();
    }
    render() {
      this.textContent.length > this.limit &&
        (this.isOpen
          ? ((this.innerHTML = this.originalHTML),
            (this.querySelector("p:last-child").innerHTML = `\n          ${
              this.querySelector("p:last-child").innerHTML
            }\n          <button type="button">${
              this.less
            }</button>\n        `))
          : (this.innerHTML = `\n          <p>\n            ${this.originalTextContent
              .trim()
              .slice(
                0,
                this.limit
              )}&hellip;\n            <button type="button">${
              this.more
            }</button>\n          </p>\n        `),
        this.querySelector("button")?.addEventListener(
          "click",
          this.toggle.bind(this)
        ));
    }
    toggle(t) {
      this.toggleAttribute("open");
    }
  }
  customElements.define("read-more", i);
})();
